module.exports = __webpack_public_path__ + "static/media/male-concierge.48c16b93.png";